import { UserRoles } from '../../../utils/constants';

export const supportPermissions = {
    'category.newCategory': [UserRoles.Admin],
    'category.editCategory': [UserRoles.Admin],
    'category.newSubCategory': [UserRoles.Admin],
    'supportTab.optionContainer': [UserRoles.Admin],
    'delete.comment': [UserRoles.Admin],
    'support.team': [UserRoles.Admin],
};